import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';

const DeleteDashboardDialog = ({
  open,
  onClose,
  onConfirm,
  onCancel,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">Delete Dashboard</DialogTitle>
    <DialogContent>
      <div>Are you sure you want to delete this dashboard?</div>
      <div><strong>This action cannot be undone.</strong></div>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        color="secondary"
        autoFocus
        variant="contained"
      >
        Delete Dashboard
      </Button>
    </DialogActions>
  </Dialog>
);

DeleteDashboardDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
};

DeleteDashboardDialog.defaultProps = {
  open: false,
  onClose: () => {},
  onConfirm: () => {},
  onCancel: () => {},
};

export default DeleteDashboardDialog;
